import * as constants from '../constants/constants';

const defaultStore = {
  trainingVideosList: [],
  templateTrainingVideosList: [],
  trainingsSubtemplateList: [],
  templateVideo: [],
  choosedVideosTags: [],
  videosTags: [],
  activeVideo: '',
  isVideoModalOpen: false,
  subtemplateTrainingVideos: [],
  templateTrainingVideos: [],
  isLoadingDelete: false,
  isDeleteModal: false,
  trainingVideosPageCount: 0,
  trainingVideosCurrentPage: 1,
  limberingUpVideosPageCount: 0,
  limberingUpVideosCurrentPage: 1,
  interruptionVideosPageCount: 0,
  interruptionVideosCurrentPage: 1,
  selfDevelopmentVideosPageCount: 0,
  selfDevelopmentVideosCurrentPage: 1,
  motivationVideosPageCount: 0,
  motivationVideosCurrentPage: 1,
  welcomeVideosPageCount: 0,
  welcomeVideosCurrentPage: 1,
  faqVideosPageCount: 0,
  faqVideosCurrentPage: 1,
  subtemplateTrainingVideosPageCount: 0,
  subtemplateTrainingVideosCurrentPage: 1,
  templateTrainingVideosPageCount: 0,
  templateTrainingVideosCurrentPage: 1,
  isTrainingVideosLoading: false,
  isSubtemplateTrainingVideosLoading: false,
  limberingUpVideosList: [],
  interruptionVideosList: [],
  selfDevelopmentVideosList: [],
  motivationVideosList: [],
  welcomeVideosList: [],
  faqVideosList: [],
  isCreateVideoLoading: false,
  subtemplateVideo: [],
  trainingVideo: [],
};

export default (state = defaultStore, action) => {
  switch (action.type) {
    case constants.SET_CHOOSED_VIDEOS_TAGS:
      return {
        ...state,
        videosTags: action.payload.tags,
      };
    case constants.SET_IS_VIDEO_MODAL_OPEN:
      return {
        ...state,
        isVideoModalOpen: action.payload.isVideoModalOpen,
      };
    case constants.SET_TRAINING_VIDEOS_LIST:
      return {
        ...state,
        trainingVideosList: action.payload.trainingVideosList,
      };
    case constants.SET_TRAINING_VIDEO:
      return {
        ...state,
        trainingVideo: action.payload.trainingVideo,
      };
    case constants.SET_SUBTEMPLATE_VIDEO:
      return {
        ...state,
        subtemplateVideo: action.payload.subtemplateVideo,
      };
    case constants.SET_TEMPLATE_VIDEO:
      return {
        ...state,
        templateVideo: action.payload.templateVideo,
      };
    case constants.SET_ACTIVE_VIDEO:
      return {
        ...state,
        activeVideo: action.payload.activeVideo,
      };
    case constants.SET_TEMPLATE_TRAINING_VIDEOS:
      return {
        ...state,
        templateTrainingVideosList: action.payload.templateTrainingVideosList,
      };
    case constants.SET_SUBTEMPLATE_TRAINING_VIDEOS:
      return {
        ...state,
        trainingsSubtemplateList: action.payload.trainingsSubtemplateList,
      };
    case constants.SET_SUBTEMPLATE_TRAINING_VIDEOS_PAGE_COUNT:
      return {
        ...state,
        subtemplateTrainingVideosPageCount: action.payload.pageCount,
      };
    case constants.SET_SUBTEMPLATE_TRAINING_VIDEOS_CURRENT_PAGE:
      return {
        ...state,
        subtemplateTrainingVideosCurrentPage: action.payload.currentPage,
      };
    case constants.SET_TEMPLATE_TRAINING_VIDEOS_PAGE_COUNT:
      return {
        ...state,
        templateTrainingVideosPageCount: action.payload.pageCount,
      };
    case constants.SET_TEMPLATE_TRAINING_VIDEOS_CURRENT_PAGE:
      return {
        ...state,
        templateTrainingVideosCurrentPage: action.payload.currentPage,
      };
    case constants.SET_LOADING_DELETE:
      return {
        ...state,
        isLoadingDelete: true,
      };
    case constants.SET_END_LOADING_DELETE:
      return {
        ...state,
        isLoadingDelete: false,
      };
    case constants.OPEN_DELETE_MODAL:
      return {
        ...state,
        isDeleteModal: true,
      };
    case constants.CLOSE_DELETE_MODAL:
      return {
        ...state,
        isDeleteModal: false,
      };
    case constants.SET_TRAINING_VIDEOS_PAGE_COUNT:
      return {
        ...state,
        trainingVideosPageCount: action.payload.pageCount,
      };
    case constants.SET_TRAINING_VIDEOS_CURRENT_PAGE:
      return {
        ...state,
        trainingVideosCurrentPage: action.payload.currentPage,
      };
    case constants.SET_LIMBERING_UP_VIDEOS_PAGE_COUNT:
      return {
        ...state,
        limberingUpVideosPageCount: action.payload.pageCount,
      };
    case constants.SET_LIMBERING_UP_VIDEOS_CURRENT_PAGE:
      return {
        ...state,
        limberingUpVideosCurrentPage: action.payload.currentPage,
      };
    case constants.SET_INTERRUPTION_VIDEOS_PAGE_COUNT:
      return {
        ...state,
        interruptionVideosPageCount: action.payload.pageCount,
      };
    case constants.SET_INTERRUPTION_VIDEOS_CURRENT_PAGE:
      return {
        ...state,
        interruptionVideosCurrentPage: action.payload.currentPage,
      };
    case constants.SET_SELF_DEVELOPMENT_VIDEOS_PAGE_COUNT:
      return {
        ...state,
        selfDevelopmentVideosPageCount: action.payload.pageCount,
      };
    case constants.SET_SELF_DEVELOPMENT_VIDEOS_CURRENT_PAGE:
      return {
        ...state,
        selfDevelopmentVideosCurrentPage: action.payload.currentPage,
      };
    case constants.SET_MOTIVATION_VIDEOS_PAGE_COUNT:
      return {
        ...state,
        motivationVideosPageCount: action.payload.pageCount,
      };
    case constants.SET_MOTIVATION_VIDEOS_CURRENT_PAGE:
      return {
        ...state,
        motivationVideosCurrentPage: action.payload.currentPage,
      };
    case constants.SET_WELCOME_VIDEOS_PAGE_COUNT:
      return {
        ...state,
        welcomeVideosPageCount: action.payload.pageCount,
      };
    case constants.SET_WELCOME_VIDEOS_CURRENT_PAGE:
      return {
        ...state,
        welcomeVideosCurrentPage: action.payload.currentPage,
      };
    case constants.SET_FAQ_VIDEOS_PAGE_COUNT:
      return {
        ...state,
        faqVideosPageCount: action.payload.pageCount,
      };
    case constants.SET_FAQ_VIDEOS_CURRENT_PAGE:
      return {
        ...state,
        faqVideosCurrentPage: action.payload.currentPage,
      };
    case constants.SET_TRAINING_VIDEOS_LOADING:
      return {
        ...state,
        isTrainingVideosLoading: true,
      };
    case constants.SET_TRAINING_VIDEOS_END_LOADING:
      return {
        ...state,
        isTrainingVideosLoading: false,
      };
    case constants.IS_CREATE_VIDEO_LOADING:
      return {
        ...state,
        isCreateVideoLoading: true,
      };
    case constants.IS_CREATE_VIDEO_END_LOADING:
      return {
        ...state,
        isCreateVideoLoading: false,
      };
    case constants.SET_SUBTEMPLATE_TRAINING_VIDEOS_LOADING:
      return {
        ...state,
        isSubtemplateTrainingVideosLoading: true,
      };
    case constants.SET_SUBTEMPLATE_TRAINING_VIDEOS_END_LOADING:
      return {
        ...state,
        isSubtemplateTrainingVideosLoading: false,
      };
    case constants.SET_LIMBERING_UP_VIDEOS_LIST:
      return {
        ...state,
        limberingUpVideosList: action.payload.limberingUpVideosList,
      };
    case constants.SET_INTERRUPTION_VIDEOS_LIST:
      return {
        ...state,
        interruptionVideosList: action.payload.interruptionVideosList,
      };
    case constants.SET_SELF_DEVELOPMENT_VIDEOS_LIST:
      return {
        ...state,
        selfDevelopmentVideosList: action.payload.selfDevelopmentVideosList,
      };
    case constants.SET_MOTIVATION_VIDEOS_LIST:
      return {
        ...state,
        motivationVideosList: action.payload.motivationVideosList,
      };
    case constants.SET_WELCOME_VIDEOS_LIST:
      return {
        ...state,
        welcomeVideosList: action.payload.welcomeVideosList,
      };
    case constants.SET_FAQ_VIDEOS_LIST:
      return {
        ...state,
        faqVideosList: action.payload.faqVideosList,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/trainingVideos.js